<div class="row">
    <div class="col-12">
          <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
            <ng-container matColumnDef="uid">
              <th mat-header-cell *matHeaderCellDef> <h5>User ID</h5> </th>
              <td mat-cell *matCellDef="let element"> {{element.payload.doc.data().uid}} </td>
            </ng-container>
  
            <ng-container matColumnDef="blank">
              <th mat-header-cell *matHeaderCellDef> <h5>&nbsp;&nbsp;&nbsp;&nbsp;</h5> </th>
              <td mat-cell *matCellDef="let element"> &nbsp;&nbsp; &nbsp;&nbsp;</td>
            </ng-container>
            
            <ng-container matColumnDef="pid">
                <th mat-header-cell *matHeaderCellDef> <h5>Plan</h5> </th>
                <td mat-cell *matCellDef="let element"> {{element.payload.doc.data().pid}}</td>
            </ng-container>
            
            <ng-container matColumnDef="total">
                <th mat-header-cell *matHeaderCellDef> <h5>Total</h5> </th>
                <td mat-cell *matCellDef="let element">Rs. {{element.payload.doc.data().total}} </td>
              </ng-container>

              <ng-container matColumnDef="payid">
                  <th mat-header-cell *matHeaderCellDef> <h5>Payment ID</h5> </th>
                  <td mat-cell *matCellDef="let element"> {{element.payload.doc.data().payid}} </td>
                </ng-container>
  
            
            <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef> <h5>Action</h5> </th>
                <td mat-cell *matCellDef="let element"> 
                    <button class="btn btn-outline-danger mat-elevation-z8" (click)="goDelete(element.payload.doc.id)">Delete</button> 
                </td>
            </ng-container>
          
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
        
        <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
    </div>
</div>